import Home from './components/Home'
import List from './components/List'
import Show from './components/Show'
import Registration from './components/wizard/Registration'
import RegistrationPersonal from './components/wizard/Personal'
import RegistrationPhysical from './components/wizard/Physical'
import RegistrationEvent from './components/wizard/Event'
import RegistrationConfirmation from './components/wizard/Confirmation'

export default [
  {path: '/registration', component: Home, name: 'registration.home', meta: {auth: false}},
  {path: '/registration/all', component: List, name: 'registration.index'},
  {path: '/registration/:id/show/:tab?', component: Show, name: 'registration.show'},
  {
    path: '/registration/register',
    component: Registration,
    name: 'registration.register',
    children: [
      {path: 'personal', component: RegistrationPersonal, name: 'registration.store.personal', props: true, meta: {auth: false}},
      {path: 'physical', component: RegistrationPhysical, name: 'registration.store.physical', props: true, meta: {auth: false}},
      {path: 'event', component: RegistrationEvent, name: 'registration.store.event', props: true, meta: {auth: false}},
      {path: 'confirmation', component: RegistrationConfirmation, name: 'registration.store.confirmation', props: true, meta: {auth: false}}
    ]
  }
]
